// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CkeV","left":"styles_left__2TMiC"};